export function getHubMessageFromJson(json) {
    try {
      const data = JSON.parse(json);
      return data.content;
    } catch (e) {
      return "";
    }
}

export function getHubNameFromKitchenId(kitchenId) {
  return `10${kitchenId}01`;
}